// 生产计划负责人值php订单处有做判断
const openOrders = [{
    key:"0",
    value:"Yes"
},{
    key:"1",
    value:"No"
}];

export { openOrders };